// src/exercises/SyllablesWrapper.js
import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import Syllables from './Syllables';
import config from './syllablesConfig';

export default function SyllablesWrapper() {
    const { level } = useParams();
    const navigate = useNavigate();

    const currentLevel = parseInt(level);
    localStorage.setItem('level', currentLevel);

    return (
        <Syllables
            level={currentLevel}
            onValidate={() => {
                const nextLevel = currentLevel + 1;
                if (nextLevel > config.totalLevels) {
                    navigate(`/exercise/syllables/congratulations`);
                } else {
                    navigate(`/exercise/syllables/main/${nextLevel}`);
                }
            }}
        />
    );
}
